declare var swal: any;
import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { AppFeaturesList } from '../../../../constants/constants';
import { AllActorCertificatesRequest, AllActorCertificatesInfoController, ActorCertificatesInfoByRegistryController } from '../../../../models/actor/actor';
import { HCPService } from '../../../../services/hcp.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
//import  './profilesteps.js';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { AllCertificatesViewPipe } from '../../../../pipes/actors/allcertificatesview.pipe';
import { NgbActorDocsModal } from '../modals/actordocs/actordocs.modal';
//import { NgbDocVerTrackModal } from '../../../registry/admin/nurses/profiles/v2/modal/docvertrack.modal';
import { routerTransition } from '../../../../animations/router.animations';

declare var mess1: any;
declare var stepObject: any;
declare var pSteps: any;
declare var webGlObject: any;
//import * as jsPDF from 'jspdf'
//declare var jsPDF: any; // Important
//import * as jsPDF from 'jspdf';
//import { autoTable }  from 'jspdf-autotable';
//import * as jsPDF from 'jspdf';
//import { autoTable } from 'jspdf-autotable';
//require('jspdf-autotable');


@Component({
  selector: 'allcertificatesview',
  templateUrl: './allcertificatesview.component.html',
  styleUrls: ['./allcertificatesview.component.scss']
  , animations: [routerTransition()]
})

export class AllCertificateListComponent implements OnInit {




  // For Search
  pdata: any[];// = this.data;
  listFilter: string;
  searchTitle: string = "Search:";
  sort: any = {
    column: 'UserName',
    descending: false
  };
  //

  @Input() ActorCode: number =0;
  @Input() ActorType: number;
  @Input() index: number = 0;

  CurrentAllActorCertificatesRequest: AllActorCertificatesRequest;
  CurrentAllActorCertificatesInfoController: AllActorCertificatesInfoController[];

  CurrentActorCertificatesInfoByRegistryControllerByCode: ActorCertificatesInfoByRegistryController;

  public isRequesting: boolean = false;

  public ApiResData: ApiResponseModel;




  //
  public IsSetAccessRights: boolean;

  public CertificateType: string;


  public CanShowAllCertificateList: number = 0;
  public CanEditAllCertificateList: number = 0;


  constructor(private router: Router,
    private route: ActivatedRoute, private loaderService: SpinnerService, private hcpservice: HCPService,
    private modalService: NgbModal, private filter: AllCertificatesViewPipe) {

   

    
  }


  ngOnInit() {

    this.CurrentActorCertificatesInfoByRegistryControllerByCode = new ActorCertificatesInfoByRegistryController();
    this.CurrentAllActorCertificatesRequest = new AllActorCertificatesRequest();
    this.CurrentAllActorCertificatesInfoController = new Array<AllActorCertificatesInfoController>();
    if (this.ActorCode <= 0) {
      this.CurrentAllActorCertificatesRequest.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;

      this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    }
    else {
      this.CurrentAllActorCertificatesRequest.ActorCode = this.ActorCode;
    }
    this.CurrentAllActorCertificatesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;



    this.onSetFeatureAccessConfig();

    this.GetAllActorCertificatesInfoController();


  }


  GetAllActorCertificatesInfoController() {
    this.StartRefreshing();
    this.hcpservice.GetAllActorCertificatesInfoController(this.CurrentAllActorCertificatesRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //  console.log('this.ApiResData.Result-->' + this.ApiResData.Result.length);
          this.CurrentAllActorCertificatesInfoController = this.ApiResData.Result;
          this.pdata = this.CurrentAllActorCertificatesInfoController;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


      (error) => {

        if (error == "401 - Unauthorized") {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();



        }
        else {
          alertFunctions.AlertParamEr(error);
          this.stopRefreshing();
        }
      }


      );

  }

  //onprint() {
  //      var doc = new jsPDF();
  //  doc.text('Hello world!', 10, 10)
  //  doc.save('a4.pdf')

    
  //}

  //Search
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentAllActorCertificatesInfoController;
    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        this.pdata = this.filter.transform(this.CurrentAllActorCertificatesInfoController, this.listFilter);
      }
    }
  }


  ////////////////
  selectedClass(columnName: string): any {
    return columnName == this.sort.column ? 'sort-' + this.sort.descending : false;
  }

  changeSorting(columnName: string): void {
    var sort = this.sort;
    if (sort.column == columnName) {
      sort.descending = !sort.descending;
    } else {
      sort.column = columnName;
      sort.descending = false;
    }
  }

  convertSorting(): string {
    return this.sort.descending ? '-' + this.sort.column : this.sort.column;
  }





  //



  onSetFeatureAccessConfig() {




    this.IsSetAccessRights = true;





    //
  }

  openDocContent(l: AllActorCertificatesInfoController) {
    if (l.ActorDocCode > 0) {
      let options: NgbModalOptions = {
        size: 'lg'
      };
      const modalRef = this.modalService.open(NgbActorDocsModal,options);
      modalRef.componentInstance.ActorDocCode = l.ActorDocCode;
      modalRef.componentInstance.CanShow = 1;
      modalRef.componentInstance.CanEdit = 1;
      modalRef.result.then(x => { this.GetAllActorCertificatesInfoController() })


    }
    else {
      alertFunctions.AlertParam('acccess Denied...!');
    }
  }
  //

  //ViewVerTrack(l: AllActorCertificatesInfoController) {

  //  if (l.ActorDocCode > 0 && l.ActorDocVerCode > 0) {

  //    let options: NgbModalOptions = {
  //      size: 'lg'
  //    };
  //    this.CurrentActorCertificatesInfoByRegistryControllerByCode.Code = l.Code;
  //    this.CurrentActorCertificatesInfoByRegistryControllerByCode.FromTable = l.FromTable;
  //    this.CurrentActorCertificatesInfoByRegistryControllerByCode.CertificateType = l.CertificateType;
  //    this.CurrentActorCertificatesInfoByRegistryControllerByCode.ActorCode = l.ActorCode;
  //    this.CurrentActorCertificatesInfoByRegistryControllerByCode.CredentialTypeCode = l.CredentialTypeCode;
  //    this.CurrentActorCertificatesInfoByRegistryControllerByCode.CredentialType = l.CredentialType;
  //    this.CurrentActorCertificatesInfoByRegistryControllerByCode.CredentialTypeGroup = l.CredentialTypeGroup;
  //    this.CurrentActorCertificatesInfoByRegistryControllerByCode.GroupOrFolder = l.GroupOrFolder;
  //    this.CurrentActorCertificatesInfoByRegistryControllerByCode.CredentialNumber = l.CredentialNumber;
  //    this.CurrentActorCertificatesInfoByRegistryControllerByCode.ValidFrom = l.ValidFrom;
  //    this.CurrentActorCertificatesInfoByRegistryControllerByCode.ValidTo = l.ValidTo;
  //    this.CurrentActorCertificatesInfoByRegistryControllerByCode.IssuingAuthority = l.IssuingAuthority;
  //    this.CurrentActorCertificatesInfoByRegistryControllerByCode.AdditionalDetail = l.AdditionalDetail;
  //    this.CurrentActorCertificatesInfoByRegistryControllerByCode.Remarks = l.Remarks;
  //    this.CurrentActorCertificatesInfoByRegistryControllerByCode.ExtData = l.ExtData;
  //    this.CurrentActorCertificatesInfoByRegistryControllerByCode.IssuingAuthorityLongValue = l.IssuingAuthorityLongValue;
  //    this.CurrentActorCertificatesInfoByRegistryControllerByCode.ActorDocCode = l.ActorDocCode;
  //    this.CurrentActorCertificatesInfoByRegistryControllerByCode.DocCount = l.DocCount;
  //    this.CurrentActorCertificatesInfoByRegistryControllerByCode.IsDocVerInciated = l.IsDocVerInciated;
  //    this.CurrentActorCertificatesInfoByRegistryControllerByCode.ActorDocVerCode = l.ActorDocVerCode;

 
  //    this.CurrentActorCertificatesInfoByRegistryControllerByCode.SuperRegistryActorCode = l.SuperRegistryActorCode;

  //    const modalRef = this.modalService.open(NgbDocVerTrackModal, options);
  //    modalRef.componentInstance.ActorCertificatesInfoByRegistryControllerByCode = l;
  //    modalRef.componentInstance.FacilityActorCode = l.SuperRegistryActorCode;
  //    modalRef.componentInstance.CanShow = 1;
  //    modalRef.componentInstance.CanEdit = 0;
  
  //  }
  //  else {
  //    alertFunctions.AlertParam('acccess Denied...!');
  //  }

  //}


  //

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }




}
